var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import ButtonBase from "@irati/ui/src/Button";
import { FormattedMessage } from "@irati/utils/lang";
var Button = styled(ButtonBase)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  box-shadow: inset 0 0 0 1px #D8D8D7, inset 0 -2px 0 1px #D8D8D7;\n"], ["\n  width: 100%;\n  box-shadow: inset 0 0 0 1px #D8D8D7, inset 0 -2px 0 1px #D8D8D7;\n"])));
var LoadMore = /** @class */ (function (_super) {
    __extends(LoadMore, _super);
    function LoadMore() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadMore.prototype.render = function () {
        var onClick = this.props.onClick;
        return (React.createElement(Button, { onClick: onClick },
            React.createElement(FormattedMessage, { id: "reward.catalogue.loadmore" })));
    };
    return LoadMore;
}(PureComponent));
export default LoadMore;
var templateObject_1;
